import React from 'react';
import ConfirmSwitch from '../../microComponents/modals/ConfirmSwitch';
import ExportSwitch from "../../microComponents/modals/ExportSwitch";

const BatchColumn = () => {


    const columns = [{
        title: 'ردیف', dataIndex: 'row', className: "hidden  lg:table-cell",
        key: 'row', render: (text, row, index) => {
            return index + 1;
        },
    }, {
        title: 'واحد', dataIndex: 'branch', key: 'branch',
    }, {
        title: 'خط تولید', dataIndex: 'productLine', key: 'productLine',
    }, {
        title: 'شماره بچ', dataIndex: 'batchNumber', key: 'batchNumber', className: "hidden   2xs:table-cell",
    }, {
        title: 'محصول', dataIndex: 'product', key: 'product', className: "hidden   3xs:table-cell",
    }, {
        title: '  چاپ شده', dataIndex: 'printedCounter', key: 'printedCounter', className: "hidden   3xs:table-cell",
    },

        {
            title: 'تحویل به انبار',
            dataIndex: 'registredCounter',
            key: 'registredCounter',
            className: "hidden   sm:table-cell",
            render: (item, row) => {
                return <div>{row.totalRgisterdCounter > 0 && (`${row.registredCounter} (${row.totalRgisterdCounter}) `)}</div>

            }
        },

        {
            title: 'ابطال ',
            dataIndex: 'cancleCounter',
            key: 'cancleCounter',
            className: "hidden   md:table-cell",
        }, {
            title: 'در حال بررسی',
            dataIndex: 'quarantineCounter',
            className: "hidden   2md:table-cell",
            key: 'quarantineCounter',
            render: (item, row) => {
                return <div>{row.totalQuarantineCounter > 0 && (`${row.quarantineCounter} (${row.totalQuarantineCounter}) `)}</div>

            }
        },

        {
            title: 'امحا',
            dataIndex: 'destroyedCounter',
            key: 'destroyedCounter',
            className: "hidden   lg:table-cell",
            render: (item, row) => {
                // todo test this line
                return <div>{row.totalDestroyedCounter > 0 && (`${row.destroyedCounter} (${row.totalDestroyedCounter}) `)}</div>
            }
        }, {
            title: 'بازسازی شده', className: "hidden   lg:table-cell",
            dataIndex: 'totalReconstructCounter',
            key: 'totalReconstructCounter',
            render: (item) => {
                return <span>{!!item && item}</span>
            }

        },
        // {
        //     title: 'تعداد در پالت ',
        //     dataIndex: 'numberPerPallet',
        //     key: 'numberPerPallet',
        //     className: "hidden   lg:table-cell",
        //
        //
        // },

        {
            title: 'کنترل کیفی',
            dataIndex: 'qualityControlAdmin',
            key: 'qualityControlAdmin',
            className: "hidden   lg:table-cell",
        }, {
            title: 'تاریخ ثبت', dataIndex: 'created', key: 'created', className: "hidden   lg:table-cell",
        },
        {
            title: 'زمان پایان ', className: "hidden   lg:table-cell",
            dataIndex: 'stopDate',
            key: 'stopDate',
        },
        {
            title: ' صادراتی',
            className: 'cell-fix-left left-106',
            dataIndex: 'forExport',
            key: 'forExport',
            fixed: 'right',
            render: (text, row) => {
                return <div className="text-center d-flex flex-column w-100">
                    <div className='text-center d-flex gap-1 d-flex justify-content-center'>

                        <ExportSwitch  rowData={row} defStatus={row.forExport}/>
                    </div>
                </div>

            },
        },
        {
            title: 'وضعیت',
            className: 'cell-fix-left',
            dataIndex: 'function',
            key: 'function',
            fixed: 'right',
            render: (text, row) => {
                return <div className="text-center d-flex flex-column w-100">
                    <div className='text-center d-flex gap-1 d-flex justify-content-center'>

                        <ConfirmSwitch hidden={row.status === null} rowData={row} defStatus={row.status}/>
                    </div>
                </div>

            },
        },

    ];
    return [columns]
};

export default BatchColumn;